export const billableStatuses = {
  billable: 'Billable',
  investedAkvelon: 'Invested - akvelon',
  investedClient: 'Invested - client',
  internalClient: 'Internal - client',
};
